import Vue from 'vue';
import Vuex from 'vuex';

import infoData from './modules/info';
import fishbowlOrders from './modules/fishbowl';
import workareaOrders from './modules/workarea';
import vtexOrders from './modules/vtex';
import fishiondata from './modules/fishion';
import countries from './modules/countries';

// import * as actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    infoData,
    fishbowlOrders,
    workareaOrders,
    vtexOrders,
    fishiondata,
    countries,
  },
});



// WEBPACK FOOTER //
// /src/store/store.js